export function BpS() {
  return minWidth(500);
}

export function BpM() {
  return minWidth(900);
}

export function minWidth(breakpoint: number) {
  return `@media only screen and (min-width: ${breakpoint.toString()}px)`
}


// WEBPACK FOOTER //
// ./src/shared/brakepoints.tsx